<template>
  <div>
    <!-- 返回 -->
    <div class="return">
      <router-link to="/">返回首页</router-link>

    </div>
    <!-- 返回 -->
    <!-- 内容 -->
    <div class="container">
      <h2 class="title1">技术参数</h2>
      <div class="container-content">
        <p class="text_square" >主要组件</p>
        <table class="technical_parameter">
          <tbody>
            <tr>
              <td width="144" class="con50">总长</td>
              <td width="191" class="con50">1,772 mm</td>
            </tr>
            <tr>
              <td>车宽</td>
              <td>689 mm</td>
            </tr>
            <tr>
              <td>车高</td>
              <td>1,118 mm</td>
            </tr>
            <tr>
              <td>轴距</td>
              <td>1,249 mm</td>
            </tr>
            <tr>
              <td>最小离地间隙</td>
              <td>133 mm</td>
            </tr>
            <tr>
              <td>前伸角</td>
              <td>27&deg;</td>
            </tr>
            <tr>
              <td>前伸距</td>
              <td>72 mm</td>
            </tr>
            <tr>
              <td>整备重量</td>
              <td>111 kg</td>
            </tr>
            <tr>
              <td id="zdzz">最大载量<sup>*1</sup></td>
              <td>176 kg</td>
            </tr>
            <tr>
              <td id="zy2">最大行李重量<sup>*2</sup></td>
              <td>购物钩和手套箱&nbsp;&nbsp;&nbsp;&nbsp;1.5 kg
              <br>衣帽箱&nbsp;&nbsp;&nbsp;&nbsp;10 kg</td>
            </tr>
            <tr>
              <td>允许的最大重量</td>
              <td>287 kg</td>
            </tr>
            <tr>
              <td>允许的最大车轴重量</td>
              <td>前&nbsp;&nbsp;&nbsp;&nbsp;87 kg<br>
              后&nbsp;&nbsp;&nbsp;&nbsp;200 kg</td>
            </tr>
            <tr>
              <td>承载人数</td>
              <td>驾驶员和 1 名乘客</td>
            </tr>
            <tr>
              <td>最小转弯半径</td>
              <td>1.90 m</td>
            </tr>
            <tr>
              <td>排量</td>
              <td>125 cm<sup>3</sup></td>
            </tr>
            <tr>
              <td>缸径 × 冲程</td>
              <td>52.4 × 57.9 mm</td>
            </tr>
            <tr>
              <td>压缩比</td>
              <td>9.8:1</td>
            </tr>
            <tr>
              <td>最大功率</td>
              <td>6.87 kw/7,500 r/min (rpm)</td>
            </tr>
            <tr>
              <td>最大扭矩</td>
              <td>10.3 N·m/6,000 r/min (rpm)</td>
            </tr>
            <tr>
              <td>最大速度</td>
              <td>87 km/h</td>
            </tr>
            <tr>
              <td>爬坡能力</td>
              <td>≥ 16&deg;</td>
            </tr>
            <tr>
              <td>燃油消耗量</td>
              <td>≤ 2.1 L/100 km<br />（按 GB15744-2019 实测）</td>
            </tr>
            <tr>
              <td>燃油消耗量限值</td>
              <td>2.5 L/100 km<br />（按 GB15744-2019 要求）</td>
            </tr>
            <tr>
              <td>燃油</td> 
              <td>推荐的无铅汽油：<br>
              91 RON或以上</td>
            </tr>
            <tr>
              <td>含酒精的燃油</td>
              <td>乙醇含量最高为10％</td>
            </tr>
            <tr>
              <td>油箱容量</td>
              <td>6.4 升</td>
            </tr>
            <tr>
              <td>蓄电池</td>
              <td>MTX7L-RS<br>12 V-6 Ah (10 小时)</td>
            </tr>
            <tr>
              <td>驱动型式</td>
              <td>皮带传动</td>
            </tr>
            <tr>
              <td>初级传动比</td>
              <td>V-Matic (2.64:1 - 0.88:1)</td>
            </tr>
            <tr>
              <td>末级传动比</td>
              <td>8.615</td>
            </tr>

          </tbody>
        </table>
        <p>*1 包括驾驶员、乘客、所有行李和附件<br>*2 包括行李和添加附件的重量</p>


        <p class="text_square">维修数据</p>
        <table class="technical_parameter">
        <tbody>
            <tr>
              <td class="con50">轮胎规格</td>
              <td class="con50">前&nbsp;&nbsp;&nbsp;&nbsp;90/90-12 44J<br>
              后&nbsp;&nbsp;&nbsp;&nbsp;100/90-10 56J</td>
            </tr>
            <tr>
              <td>轮胎类型</td>
              <td>斜交，真空胎</td>
            </tr>
            <tr>
              <td>推荐轮胎</td>
              <td>前&nbsp;&nbsp;&nbsp;&nbsp;CHENG SHIN C-922F<br>
              后&nbsp;&nbsp;&nbsp;&nbsp;CHENG SHIN C-922R</td>
            </tr>
            <tr>
              <td>
              胎压</td>
              <td>前&nbsp;&nbsp;&nbsp;&nbsp;[仅驾驶员一人]
              <br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;175 kPa
              <br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;[驾驶员和乘客]
              <br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;175 kPa
              <br>后&nbsp;&nbsp;&nbsp;&nbsp;[仅驾驶员一人]<br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;200 kPa<br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;[驾驶员和乘客]<br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;225 kPa</td>
            </tr>
            <tr>
              <td id="hhs">火花塞</td>
              <td>（标准） CPR7EA-9 (NGK)</td>
            </tr>
            <tr>
              <td>火花塞间隙</td>
              <td>0.8 - 0.9 mm</td>
            </tr>
            <tr>
              <td>怠速转速</td>
              <td>1,700 ± 100 rpm</td>
            </tr>
            <tr>
              <td height="34" id="fadongjituij">推荐发动机机油</td>
              <td>本田 4 冲程摩托车机油 API 维修类别 SG 或更高，不包括标为“节能”或“节省资源”的机油 SAE 10W-30，JASO T 903 标准 MB</td>
            </tr>
            <tr>
              <td id="baodongjijiyou">发动机机油容量</td>
              <td>放油后&nbsp;&nbsp;&nbsp;&nbsp;0.7 升<br />
              排空并清洁滤网后&nbsp;&nbsp;&nbsp;&nbsp;0.8 升<br />
                拆解后&nbsp;&nbsp;&nbsp;&nbsp;0.8 升</td>
            </tr>
            <tr>
              <td>变速器油容量</td>
              <td>放油后&nbsp;&nbsp;&nbsp;&nbsp;0.10 升<br>
            拆解后&nbsp;&nbsp;&nbsp;&nbsp;0.12 升</td>
            </tr>

            <tr>
              <td>推荐制动液</td>
              <td>本田 DOT 3 或 DOT 4 制动液</td>
            </tr>
          </tbody>
        </table>

        <p class="text_square" id="dengpao">灯泡</p>
        <table class="technical_parameter">
          <tbody>
            <tr>
              <td class="con50">前照灯</td>
              <td class="con50">LED</td>
            </tr>
            <tr>
              <td>制动灯 / 尾灯</td>
              <td>LED</td>
            </tr>
              <tr>
              <td>牌照灯</td>
              <td>12 V-5 W</td>
            </tr>
            <tr>
              <td>前转向信号灯</td>
              <td>LED</td>
            </tr>
            <tr>
              <td>后转向信号灯</td>
              <td>LED</td>
            </tr>
            <tr>
              <td>位置灯</td>
              <td>LED</td>
            </tr>
          </tbody>
        </table>

        <p class="text_square" id="baxs">保险丝</p>
        <table class="technical_parameter">
          <tbody>
            <tr>
              <td class="con50">主保险丝</td>
              <td class="con50">20 A</td>
            </tr>
            <tr>
              <td>其他保险丝</td>
              <td>10 A</td>
            </tr>
          </tbody>
        </table>

        <p class="text_square">扭矩规格</p>
        <table class="technical_parameter">
          <tbody>
            <tr>
              <td class="con50">发动机油塞</td>
              <td class="con50">20 N·m</td>
            </tr>
            <tr>
              <td>发动机机油泄油螺塞</td>
              <td>24 N·m</td>
            </tr>

          </tbody>
        </table>

        <p>
          以上技术参数基于 SDH125T-37A 基础款。<br />本产品执行的企业标准：Q/320585 SDH022—2021
        </p>
      </div>

      <!-- 上一页 下一页 -->
      <div class="foot-btn clearfix">
        <div class="prev"><router-link to="/block45a">上一页</router-link></div>
      </div>
      <!-- 上一页 下一页 -->
    </div>
    <!-- 内容 -->
  </div>
</template>

<script>
export default {
  props: ["id"],
  watch: {'$route'(to, from) {if(this.id != null) {setlink(this.id);}}},
  mounted() {
    setlink(this);
    // 图像热区
    // //imagehoverclick("boxmap");

  },
  methods: {
    goto(path) {this.$router.push({ path: path });}
  }
};
</script>
